/**
 * Activation token API service
 * Handles token redemption for Client Admin activation
 */

import api from './api'

export interface RedeemTokenRequest {
  token: string
}

export interface RedeemTokenResponse {
  success: boolean
  client_id?: string
  error?: string
}

export const activationApi = {
  /**
   * Redeem an activation token to become Client Admin
   */
  async redeemToken(data: RedeemTokenRequest): Promise<RedeemTokenResponse> {
    const response = await api.post<RedeemTokenResponse>('/activation/redeem-token', data)
    return response.data
  },
}

export default activationApi
